import React, { useEffect, useState } from "react";
import axios from "axios";
import Widget from "Components/Common/Widget/Widget";
import { GiMoneyStack } from "react-icons/gi";
import { TbSquareRoundedCheck, TbSquareRoundedX } from "react-icons/tb";
import UserKyc from "Components/WithdrawalRequest/KYC/UserKyc";
import { MdOutlinePending } from "react-icons/md";




const Kyc = () => {
  const [stats, setStats] = useState({
    totalRequests: 0,
    totalApproved: 0,
    totalPending: 0,
    totalOnProcess: 0,
    totalRejected: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/payout-kyc/users/stats`
        );
        if (data.success) {
          setStats(data.stats);
        }
      } catch (err) {
        console.error("Error fetching KYC stats:", err);
      }
    };

    fetchStats();
  }, []);

  return (
    <React.Fragment>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<GiMoneyStack className="h-6 w-6" />}
          title={"Total Requests Raised"}
          subtitle={stats.totalRequests}
        />
        <Widget
          icon={<TbSquareRoundedCheck className="h-6 w-6" />}
          title={"Total Approved "}
          subtitle={stats.totalApproved}
        />
        <Widget
          icon={<TbSquareRoundedX className="h-6 w-6" />}
          title={"Total Rejected "}
          subtitle={stats.totalRejected}
        />
        <Widget
          icon={<MdOutlinePending className="h-6 w-6" />}
          title={"Total On-Process "}
          subtitle={stats.totalOnProcess}
        />
        <Widget
          icon={<MdOutlinePending className="h-6 w-6" />}
          title={"Total Pending "}
          subtitle={stats.totalPending}
        />
      </div>

      <UserKyc />
    </React.Fragment>
  );
};

export default Kyc;
